import React from 'react';
import { ArrowRightIcon, EarIcon, PlayIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
import { ScreenContainer } from '../story/ScreenContainer';
import { ScreenHeading } from '../story/ScreenHeading';
import { Button } from '../story/Button';
import { SceneIllustration } from '../art/SceneIllustration';
import { SavannaScene } from '../art/SavannaScene';
import { getWorldState } from '../../utils/worldState';
import { prequelSkipRecap, purrAnchorUnlockNote } from '../../data/prequel';
const OPENING_WORLD = getWorldState({}, {});
const SCENE_TEXT = 'Dawn at the Savanna City watering hole. Solar shade roofs and acacia roots. Monkey waits at the water’s edge. Giraffe stands in the shade. Meerkats sit on a stone wall. Panther faces the grass.';
export function WelcomeScreen() {
  const {
    state,
    dispatch,
    openDialog
  } = useDemo();
  const canResume = Boolean(state.resumeScreen) && state.visitedScreens.length > 1;
  return <ScreenContainer data-id="element-334" data-mp="36crxbfbsolh5">
      {state.leftVisit && <div role="status" className="anim-enter mb-8 rounded-2xl border border-line bg-sand p-5 hc-strong" data-id="element-335" data-mp="3oesjfsc765xk">
          <p className="font-bold text-forest" data-id="element-336" data-mp="3tdn3exlwi0j9">You stepped out. That is okay.</p>
          <p data-id="element-337" data-mp="18rsnl20ihqw">Your visit is kept while this page stays open. Refreshing may clear it.</p>
        </div>}
      <div className="grid gap-10 lg:grid-cols-[1fr_1.1fr] lg:items-center" data-id="element-338" data-mp="6974g86nbh6r">
        <div data-id="element-339" data-mp="b7qw8p7x7n71">
          <ScreenHeading size="xl" data-id="element-340" data-mp="b65zqu21pu6j">What couldn’t you see?</ScreenHeading>
          <p className="mt-5 max-w-prose font-display text-xl text-forest sm:text-2xl" data-id="element-341" data-mp="g6262zy7txp9">
            Enter Savanna City with Amara. Find the clues. Check the story. Choose a safer path.
          </p>
          <p className="mt-4 max-w-prose" data-id="element-342" data-mp="oyds89maqyzf">
            A strange sound has reached the watering hole. Monkey has stopped at the edge. The group is reacting. You do
            not have the whole story yet.
          </p>
          {canResume && <div className="mt-6" data-id="element-343" data-mp="yxbcv1glq8d5">
              <Button onClick={() => dispatch({
            type: 'RESUME'
          })} icon={<PlayIcon size={18} aria-hidden="true" data-id="element-345" data-mp="2v0hikg4ddwj9" />} data-id="element-344" data-mp="2uzxz2uz2n034">
                Continue where you left off
              </Button>
            </div>}
          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:flex-wrap" data-id="element-346" data-mp="34phko8e6581o">
            <Button variant={canResume ? 'secondary' : 'primary'} onClick={() => dispatch({
            type: 'GO',
            screen: 'prequelEntry'
          })} iconAfter={<ArrowRightIcon size={18} aria-hidden="true" data-id="element-348" data-mp="3douvb4e142nz" />} data-id="element-347" data-mp="34rkktl91chk4">
              Start with SixBefore
            </Button>
            <Button variant="secondary" onClick={() => dispatch({
            type: 'COMPLETE_PREQUEL',
            route: 'skip',
            recap: `${prequelSkipRecap} ${purrAnchorUnlockNote}`
          })} data-id="element-349" data-mp="39r6zlz4ii5v1">
              Jump to Savanna City
            </Button>
            <Button variant="quiet" onClick={() => openDialog('settings')} data-id="element-350" data-mp="1tcfe865s9yv8">
              Choose how to play
            </Button>
          </div>
          <p className="mt-5 text-sm text-ink/80" data-id="element-351" data-mp="3t76nj8oqijl">About 8–12 minutes. No timer. No personal story needed.</p>
          <p className="mt-1 flex items-center gap-2 text-sm text-ink/80" data-id="element-352" data-mp="8rightyzct1t">
            <EarIcon size={16} aria-hidden="true" className="text-teal" data-id="element-353" data-mp="3q9l5yu8xlpu5" />
            This demo uses written sound cues. No headphones needed.
          </p>
        </div>
        <SceneIllustration description={SCENE_TEXT} quietTitle="Savanna City" data-id="element-354" data-mp="3v5s1ru7m5kyd">
          <SavannaScene world={OPENING_WORLD} label={SCENE_TEXT} data-id="element-355" data-mp="3h723ib925f8f" />
        </SceneIllustration>
      </div>
      <aside className="mt-12 grid gap-2 border-t border-line pt-6 md:grid-cols-[220px_1fr] md:gap-8" data-id="element-356" data-mp="3m5dbshjpfhoj">
        <h2 className="font-display text-xl font-semibold text-forest" data-id="element-357" data-mp="37ca89e2y74gt">About this demo</h2>
        <p className="max-w-prose" data-id="element-358" data-mp="3c9imx4ow0qdb">
          SevenAfter is a planned story journey across seven rewilded future Gardens. This demo shows Amara’s prequel and
          one playable moment from Garden 1. It is not the full product.
        </p>
      </aside>
    </ScreenContainer>;
}